import * as Yup from "yup";

export const eventSchema = Yup.object().shape({
  title: Yup.string().required("Event title cannot be empty"),
  description: Yup.string().nullable(),
  location: Yup.string().nullable(),
  status: Yup.string().required("Status is required"),
  host: Yup.string().nullable(),
  start_date: Yup.date()
    .required("Start date is required")
    .typeError("Start date must be a valid date"),
  end_date: Yup.date()
    .required("End date is required")
    .typeError("End date must be a valid date")
    .when("start_date", (start_date, schema) =>
      start_date
        ? schema.min(start_date, "End date cannot be before start date")
        : schema
    ),
  session_id: Yup.string().required("Year is required"),
});
